<form [formGroup]="BecodeForm" novalidate>
  <div class="container">
    <div
      class="alert"
      role="alert"
      *ngIf="loadingInitialData"
      class="alert-success"
    >
      <h4 class="alert-heading">Cargando datos</h4>
      <hr />
      <p class="mb-0">Se está cargando la información.</p>
      <app-progress></app-progress>
    </div>
  </div>

  <div
    class="container border border-success rounded"
    *ngIf="!loadingInitialData"
  >
    <div class="container">
      <div class="card border border-success mt-3">
        <h5 class="card-header">
          Solicitud Beneficios Internos Santo Tom&aacute;s
          <a
            class="d-flex justify-content-md-end"
            data-toggle="collapse"
            href="#DP"
            role="button"
            aria-expanded="true"
            aria-controls="DP"
          ></a>
        </h5>
        <div class="collapse show" id="DP">
          <div class="card-body">
            <div class="row mt-2 container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Correo de solicitante</label>
                    <input
                      type="email"
                      class="form-control form-control-sm"
                      [value]="user.CorreoElectronico"
                      disabled
                    />
                  </div>
                  <div class="col-sm-6">
                    <label>RUT</label>
                    <input
                      type="text"
                      formatRut
                      class="form-control form-control-sm"
                      [value]="user.Rut"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Nombre completo solicitante</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Ingresa primer nombre"
                      [value]="user.fullName"
                      disabled
                    />
                  </div>
                  <div class="col-sm-6">
                    <label>Sede en la que estudiará</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Ingresa la sede en la que vas a estudiar"
                      formControlName="Sede"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Beneficio a solicitar</label>
                    <select
                      formControlName="EstadoCivil"
                      class="form-control form-control-sm"
                      formControlName="Becode"
                    >
                      <option value="">Seleccione</option>
                      <option value="1">Soltero/a</option>
                      <option value="2">Casado/a</option>
                      <option value="3">Divorciado/a</option>
                      <option value="4">Viudo/a</option>
                      <option value="5">Conviviente Civil</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 container">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label>Descripci&oacute;n beneficio solicitado</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Ingresa el beneficio que quieres solicitar"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card border border-success mt-3">
        <h5 class="card-header">
          Adjuntar Documentos
          <a
            class="d-flex justify-content-md-end"
            data-toggle="collapse"
            href="#Doc"
            role="button"
            aria-expanded="true"
            aria-controls="Doc"
          ></a>
        </h5>
        <div class="collapse show" id="Doc">
          <div class="card-body">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Documento</th>
                  <th scope="col">Estado</th>
                  <th scope="col">Acci&oacute;n</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let doc of docs">
                  <th scope="row">
                    {{ doc.nombreRequerimiento }}
                    <span *ngIf="doc.obligatorio === 'S'">*</span>
                  </th>
                  <td>
                    <div class="custom-file mt-2">
                      <input
                        type="file"
                        class="custom-file-input"
                        id="inputGroupFile01"
                        aria-describedby="inputGroupFileAddon01"
                      />
                      <label class="custom-file-label" for="inputGroupFile01">
                        <span>Adjuntar </span>
                      </label>
                    </div>
                  </td>
                  <td>-------</td>
                  <td>
                    <button type="button" class="btn btn-primary btn-lg btn-sm">
                      Enviar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container" *ngIf="!loadingInitialData">
    <div class="row mb-2 mt-2">
      <div class="col-md-3">&nbsp;</div>
      <div class="col-md-3 mr-2">
        <app-apibutton
          text="Seguir&eacute; despu&eacute;s"
          [progress]="progress"
        ></app-apibutton>
      </div>
      <div class="col-md-3 ml-2">
        <app-apibutton
          text="Guardar y enviar"
          [progress]="progress"
        ></app-apibutton>
      </div>
      <div class="col-md-3">&nbsp;</div>
    </div>
  </div>
</form>
